import { saveFile } from '@ion/components';
import { camelCase, omit } from 'lodash';
import yaml from 'js-yaml';

/**
 * Download Analytics File configuration as YAML
 *
 * @param {object} params - Parameters
 * @param {object} params.settingsTemplate - The settings template from createAjsBuilderFile
 * @param {string} params.pipelineName - Name of the pipeline for the filename
 */
export default function downloadAnalyticsFile({ settingsTemplate, pipelineName }) {
  const filteredTemplate = filterSettings(settingsTemplate);
  const yamlContent = yaml.dump(filteredTemplate);
  const filename = `${camelCase(pipelineName)}-analytics-file.yaml`;

  saveFile({
    content: yamlContent,
    filename,
    mimeType: 'text/plain',
  });
}

/**
 * Filter out settings that should not be included in the download
 *
 * @param {object} settingsTemplate - The settings template from createAjsBuilderFile
 * @returns {object} Filtered settings template
 */
function filterSettings(settingsTemplate) {
  return omit(settingsTemplate, ['optimizeBuild', 'writeKey']);
}
